import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/UserGroups/userGroups/'
export const REFRESH = NAMESPACE + 'REFRESH'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_CURSOR = NAMESPACE + 'SET_CURSOR'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'

const initialState = {
  userGroups: [],
  userGroupsById: {},
  loading: false,
  loaded: false,
  cursor: null
}

const userGroupDefaults = {
  usersCount: 0,
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...initialState
      }
    case REFRESH:
      return {
        ...state,
        userGroups: [],
        userGroupsById: {},
        loading: false,
        loaded: false,
        cursor: null
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        loading: action.payload.loading,
        loaded: action.payload.loaded
      }
    case SET_CURSOR:
      return {
        ...state,
        cursor: action.payload
      }
    case ADD:
      return {
        ...state,
        userGroups: addUniqueValueToArray({
          array: state.userGroups,
          value: action.payload.id,
          index: action.payload.index
        }),
        userGroupsById: {
          ...state.userGroupsById,
          [action.payload.id]: {
            ...userGroupDefaults,
            ...action.payload
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        userGroupsById: { ...state.userGroupsById }
      }
      action.payload.forEach(item => {
        newState.userGroups = addUniqueValueToArray({
          array: newState.userGroups,
          value: item.id,
          index: item.index
        })
        newState.userGroupsById[item.id] = {
          ...userGroupDefaults,
          ...item
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        userGroups: [ ...state.userGroups.filter(id => id !== action.payload.id) ],
        userGroupsById: { ...state.userGroupsById }
      }
      delete newState.userGroupsById[action.payload.id]
      return newState
    }
    default: return state
  }
}

export function refresh () {
  return {
    type: REFRESH
  }
}

export function setLoadStatus ({ loading, loaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      loading,
      loaded
    }
  }
}

export function setCursor (payload) {
  return {
    type: SET_CURSOR,
    payload
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (array) {
  return {
    type: ADD_ARRAY,
    payload: array
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}
